import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import SiteLayout from "@/components/SiteLayout";
import HomePage from "@/pages/HomePage";
import WebsitesOfferPage from "@/pages/WebsitesOfferPage";
import PricingPage from "@/pages/PricingPage";
import ServicesPage from "@/pages/ServicesPage";
import ServiceOfferPage from "@/pages/ServiceOfferPage";
import SalesServicePage from "@/pages/SalesServicePage";
import ProductsPage from "@/pages/ProductsPage";
import LegalPage from "@/pages/LegalPage";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route element={<SiteLayout />}>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/pricing" element={<PricingPage />} />
                    <Route path="/services" element={<ServicesPage />} />
                    <Route path="/services/sales" element={<SalesServicePage />} />
                    <Route path="/services/:slug" element={<ServiceOfferPage />} />
                    <Route path="/products" element={<ProductsPage />} />
                    <Route path="/websites" element={<WebsitesOfferPage />} />
                    <Route path="/privacy" element={<LegalPage kind="privacy" />} />
                    <Route path="/terms" element={<LegalPage kind="terms" />} />
                    <Route path="/about" element={<Navigate to={{ pathname: "/", hash: "about" }} replace />} />
                    <Route path="/contact" element={<Navigate to={{ pathname: "/", hash: "contact" }} replace />} />
                    <Route path="/work" element={<Navigate to={{ pathname: "/", hash: "work" }} replace />} />
                    <Route path="/askbox" element={<Navigate to="/pricing" replace />} />
                    <Route path="/askbox/demo" element={<Navigate to="/pricing" replace />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
